module.exports = __webpack_public_path__ + "media/assets_v3/images/user-panel/confirmed-account-12eb6ed46a1ea264843d4d2594010f99.jpeg";